export const SEO_STREAMS_PRESENT = {
  h2: 'Що таке стріми та як отримувати максимум користі',
  p1: 'Стрім — це відео в онлайні, яке передається через платформу (Twitch, YouTube, Kick тощо) на сторінку автора та його підписників. Глядачі бачать трансляцію, ставлять реакції, пишуть у чат. Для автора це спосіб розвивати особистий бренд і ком’юніті, тестувати ідеї наживо та отримувати підтримку від аудиторії.',
  h3: 'Користь від прямих трансляцій для глядачів',
  p2: 'Прямі трансляції допомагають:',
  list: [
    'Дізнаватися нове: гайды, огляди ігор, софт-туторіали.',
    'Спілкуватися напряму з автором і спільнотою, отримуючи відповіді «тут і зараз»',
    'Бачити «закулісся»: реальний процес гри, монтажу чи розробки без прикрас.',
    'Брати участь в інтерактивах: голосування, челенджі, розіграші.',
  ],
};

export const SEO_STREAMS_EMPTY = {
  h2: 'Стріми невдовзі з’являться: як підготуватися та нічого не пропустити',
  p1: 'Стріми зовсім близько — готуйтеся до живих ефірів із реальним спілкуванням, інтерактивами та корисними порадами для геймерів і креаторів. Тут ви знайдете все, щоб вчасно отримати сповіщення й комфортно дивитися трансляції без пропусків.',
  h3: 'Щоб нічого не пропустити, зробіть ось що:',
  list: [
    'Увімкніть режим “Спочатку сповіщення” для каналу та закріпіть його у списку обраних.',
    'Слідкуйте за короткими анонсами в соцмережах у день стріму (у дискорді/пости з точним часом).',
    'Активуйте VOD-нагадування: якщо пропустили, переглянете запис або уривки з таймкодами.',
  ],
};
